import { Empty, List, Space, Tag, Typography } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { NotificationStatus } from 'entities/endpoints/form.notification.list';
import { FormListPageStore } from 'stores/local';

// Styles are not needed for NotificationHistoryTab

type NotificationHistoryTabProps = {
  formId: number;
  store: FormListPageStore;
};

const NotificationHistoryTab: React.FC<NotificationHistoryTabProps> = ({
  formId,
  store,
}) => {
  const { t } = useTranslation();
  const notifications = store.notifications[formId] || [];

  const getStatusTag = (status: NotificationStatus) => {
    const statusConfig = {
      [NotificationStatus.PENDING]: { color: 'default', text: t('formList.notifications.status.pending') },
      [NotificationStatus.SENDING]: { color: 'processing', text: t('formList.notifications.status.sending') },
      [NotificationStatus.SENT]: { color: 'success', text: t('formList.notifications.status.sent') },
      [NotificationStatus.FAILED]: { color: 'error', text: t('formList.notifications.status.failed') },
    };

    const config = statusConfig[status] || statusConfig[NotificationStatus.PENDING];
    return <Tag color={config.color}>{config.text}</Tag>;
  };

  const getRecipientTypeText = (type: string) => {
    return type === 'all_managers'
      ? t('formList.notifications.allManagers')
      : t('formList.notifications.wipOnly');
  };

  if (notifications.length === 0) {
    return (
      <Empty
        description={t('formList.notifications.noNotifications')}
        style={{ marginTop: 40 }}
      />
    );
  }

  return (
    <List
      dataSource={notifications}
      renderItem={(notification) => (
        <List.Item>
          <List.Item.Meta
            title={
              <Space>
                {getStatusTag(notification.status)}
                <Typography.Text type="secondary">
                  {getRecipientTypeText(notification.recipient_type)}
                </Typography.Text>
              </Space>
            }
            description={
              <Space direction="vertical" size="small" style={{ width: '100%' }}>
                <Typography.Text>{notification.message}</Typography.Text>
                <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                  {t('formList.notifications.recipientsCount', {
                    sent: notification.sent_count,
                    total: notification.recipients_count,
                  })}
                </Typography.Text>
                <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                  {t('formList.notifications.author')}: {notification.author_name} ({notification.author_email})
                </Typography.Text>
                <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                  {new Date(notification.created_at).toLocaleString()}
                </Typography.Text>
              </Space>
            }
          />
        </List.Item>
      )}
    />
  );
};

export default observer(NotificationHistoryTab);
